import { useQuery } from 'react-query';
import PESService from 'App/services/PESService';
import * as R from 'ramda';
import formatPatientSubscriptions from 'App/utils/formatPatientSubscriptions';

function useFetchPatientSubscriptionsQuery(patientId) {
    return useQuery(
        ['patient', patientId, 'subscriptions'],
        () => {
            return patientId
                ? PESService.getPatientSubscriptions(patientId).then(
                      R.compose(R.head, R.tail, formatPatientSubscriptions)
                  )
                : Promise.resolve(null);
        },
        {
            retry: false,
            refetchOnWindowFocus: false,
        }
    );
}

export default useFetchPatientSubscriptionsQuery;
